export class GiftCardBackofficeGenerateResponseDto {
  success: boolean;
  message: string;
  accepted: boolean;
}
